import { useEffect, useState } from 'react';

export default function Lightbox() {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    const onClick = (e) => {
      const img = e.target && e.target.closest ? e.target.closest('img.lb-img') : null;
      if (img && img.src) { e.preventDefault(); e.stopPropagation(); setSrc(img.src); }
    };
    const onKey = (e) => { if (e.key === 'Escape') setSrc(null); };
    document.addEventListener('click', onClick, true);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('click', onClick, true); document.removeEventListener('keydown', onKey); };
  }, []);
  if (!src) return null;
  return (
    <div onClick={() => setSrc(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <button onClick={() => setSrc(null)} aria-label="Fermer" style={{ position: 'absolute', top: 16, right: 18, width: 36, height: 36, borderRadius: '50%', background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer' }}>{'\u2715'}</button>
      <img src={src} alt="" onClick={e => e.stopPropagation()} style={{ maxWidth: '92vw', maxHeight: '88vh', objectFit: 'contain', borderRadius: 10, boxShadow: '0 8px 40px rgba(0,0,0,0.5)' }} />
    </div>
  );
}
